var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEditModal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 25.333h1.885l12.419-12.418-1.886-1.886L6.667 23.45v1.884zM28 28H4v-5.657L21.913 4.429a1.333 1.333 0 0 1 1.886 0l3.772 3.772a1.334 1.334 0 0 1 0 1.886L12.324 25.333H28V28zM20.97 9.144l1.886 1.885 1.885-1.885-1.885-1.885-1.885 1.885z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditModal);
export default __webpack_public_path__ + "static/media/ic-edit-modal.566b07b0eb9d7d2ceeeb28de6db8cfa1.svg";
export { ForwardRef as ReactComponent };